// extracted by mini-css-extract-plugin
export default {"card":"ui_card__woG1H","grey_card":"ui_grey_card__5u01e","second_title":"ui_second_title__zPN2b","icon":"ui_icon__APpsL","titles":"ui_titles__MuNY0","text":"ui_text__UPa3Z"};